import { ViewedClustersService } from '@/microfrontends/map/shared/services/ViewedClustersService';
import { type RBushItem } from '@/microfrontends/map/shared/types/Map';

import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

const viewedClustersService = new ViewedClustersService();

export const convertClusterToRBushItem = (cluster: Cluster): RBushItem => {
  const [x, y] = cluster.geometry.coordinates;

  /**
   * @todo убрать добавление флага "isViewed", когда будет сделана реализация на бэке.
   */
  const isViewed = viewedClustersService.getIsClusterViewed(cluster.id);

  if (isViewed) {
    cluster.properties ??= {};
    cluster.properties.viewed = 1;
  }

  return {
    cluster,
    maxX: x,
    maxY: y,
    minX: x,
    minY: y,
  };
};
